(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ah-collection-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ah-read-more')) {
    customElements.define(
      'ah-read-more',
      class extends HTMLElement {
        // AH (P9 fix round 1, review M1): listeners bind once (a re-connect after a morph or editor move does not
        // double-toggle), and the "fits in 3 lines" check re-runs after fonts load and on every resize.
        connectedCallback() {
          this.btn = this.querySelector('.ah-chero__more');
          this.text = this.querySelector('.ah-rte');
          if (!this.btn || !this.text) return;
          if (this._bound) {
            this.mq.addEventListener('change', this.check);
            if ('ResizeObserver' in window && !this.ro) {
              this.ro = new ResizeObserver(this.check);
              this.ro.observe(this.text);
            }
            this.check();
            return;
          }
          this._bound = true;
          this.btn.addEventListener('click', () => {
            const open = !this.hasAttribute('data-open');
            this.toggleAttribute('data-open', open);
            this.btn.setAttribute('aria-expanded', String(open));
            this.btn.textContent = open ? 'Read less' : 'Read more';
          });
          // AH (P11 U2): the clamp applies at every width now, so the query always matches.
          this.mq = matchMedia('all');
          this.check = this.check.bind(this);
          this.mq.addEventListener('change', this.check);
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.check);
          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(this.check);
            this.ro.observe(this.text);
          }
          requestAnimationFrame(this.check);
        }
        // AH (P9 fix round 2): release the observers when the element leaves the page; a re-connect re-binds them.
        disconnectedCallback() {
          this.ro?.disconnect();
          this.ro = null;
          this.mq?.removeEventListener('change', this.check);
        }
        // Hide the toggle when the intro already fits in 3 lines (only measurable while clamped).
        check() {
          if (!this.text || !this.mq || this.hasAttribute('data-open') || !this.mq.matches) return;
          const fits = this.text.scrollHeight <= this.text.clientHeight + 1;
          if (fits !== this.hasAttribute('data-fits')) this.toggleAttribute('data-fits', fits);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ah-complete-the-bed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const fmt = (p) => `£${(p / 100).toFixed(2)}`;
    const checked = (form) => [...form.querySelectorAll('input[type=checkbox]:checked:not(:disabled)')];
    // AH (P9, owner 2026-10-02): count, total and the button label ("Add n to basket" / "Add to basket" / disabled "Select an item") stay live.
    const label = (n) => (n === 0 ? 'Select an item' : n === 1 ? 'Add to basket' : `Add ${n} to basket`);
    const sum = (form) => {
      const on = checked(form);
      form.querySelector('[data-ah-ctb-n]').textContent = `${on.length} item${on.length === 1 ? '' : 's'} selected`;
      form.querySelector('[data-ah-ctb-p]').textContent = fmt(on.reduce((a, c) => a + Number(c.dataset.price), 0));
      const btn = form.querySelector('[data-ah-ctb-btn]');
      if (btn && !btn.hasAttribute('aria-busy')) { btn.textContent = label(on.length); btn.disabled = on.length === 0; }
    };
    const init = () => document.querySelectorAll('[data-ah-ctb]').forEach(sum);
    document.addEventListener('change', (e) => {
      const form = e.target instanceof Element && e.target.closest('[data-ah-ctb]');
      if (form) sum(form);
    });
    document.addEventListener('submit', async (e) => {
      const form = e.target instanceof Element && e.target.closest('[data-ah-ctb]');
      if (!form) return;
      e.preventDefault();
      const items = checked(form).map((c) => ({ id: Number(c.value), quantity: 1 }));
      if (!items.length) return;
      const err = form.querySelector('[data-ah-ctb-err]');
      const btn = form.querySelector('[data-ah-ctb-btn]');
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(`${form.dataset.root.replace(/\/$/, '')}/cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!res.ok) throw new Error((await res.json().catch(() => ({}))).description || 'Could not add to basket');
        window.location.href = form.dataset.cartUrl;
      } catch (error) {
        err.textContent = error.message;
        err.hidden = false;
        btn.removeAttribute('aria-busy');
        sum(form);
      }
    });
    document.addEventListener('shopify:section:load', init);
    // Back/forward cache: re-read the real checkbox states when the page is shown again.
    window.addEventListener('pageshow', init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ah-faq"] && !Shopify.designMode) return;
  try {
    
  // Answers can link to on-page targets: #ah-size-guide opens the size guide drawer,
  // #ah-specs opens the specifications row before the browser jumps to it.
  document.addEventListener('click', (e) => {
    const a = e.target instanceof Element && e.target.closest('.ah-faq a[href="#ah-size-guide"], .ah-faq a[href="#ah-specs"]');
    if (!a) return;
    const target = document.getElementById(a.getAttribute('href').slice(1));
    if (!target) return;
    const dialog = target.querySelector('dialog');
    if (dialog) {
      e.preventDefault();
      if (!dialog.open) dialog.showModal();
    } else if (target instanceof HTMLDetailsElement) {
      target.open = true;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ah-print-explorer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('.ah-px__chips button');
    if (!chip) return;
    const root = chip.closest('[data-ah="print-explorer"]');
    const tag = chip.dataset.tag;
    const allCount = Number(root.dataset.allCount) || 12;
    root.querySelectorAll('.ah-px__chips button').forEach((b) => b.setAttribute('aria-pressed', String(b === chip)));
    let shown = 0;
    root.querySelectorAll('.ah-px__item').forEach((item) => {
      const match = tag ? item.dataset.tags.includes(`|${tag}|`) : shown < allCount;
      item.hidden = !match;
      if (match) shown++;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ah-tabbed-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('.ah-tabs__list [role="tab"]');
    if (!tab) return;
    const root = tab.closest('[data-ah="tabbed-products"]');
    root.querySelectorAll('[role="tab"]').forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
    root.querySelectorAll('[role="tabpanel"]').forEach((p) => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ah-welcome-popup"] && !Shopify.designMode) return;
  try {
    
customElements.get('ah-welcome-popup')||customElements.define('ah-welcome-popup',class extends HTMLElement{
connectedCallback(){
const d=this.d=this.querySelector('dialog'),f=this.querySelector('form'),P=/customer_posted=true/.test(location.search);
this.D=!!(window.Shopify&&Shopify.designMode);
d.addEventListener('close',()=>{this.set(1);this.r?.focus?.()});
this.addEventListener('click',e=>{const t=e.target,c=t.closest('[data-copy]');(t==d||t.closest('[data-close]'))&&d.close();c&&this.copy(c)});
f?.addEventListener('submit',e=>this.send(e,f));
if(this.D){const m=e=>e.detail?.sectionId==this.dataset.section;this.on=e=>m(e)&&this.open();this.off=e=>m(e)&&d.close();this.ev('add');return}
if(P&&this.get()=='p'&&this.querySelector('[data-posted]'))return this.open();
P&&this.set(1);
if(this.get())return;
const go=()=>{this.stop();this.get()||this.open()},start=()=>{
this.t=setTimeout(go,this.dataset.delay*1e3);
const h=document.documentElement.scrollHeight,v=innerHeight,y=(h-v)*this.dataset.scroll/100+v-2,s=this.s=document.createElement('div');
if(h-v<50)return;
s.style.cssText=`position:absolute;left:0;width:1px;top:${y}px;height:${h-y}px;pointer-events:none`;
document.body.append(s);
(this.o=new IntersectionObserver(x=>x[0].isIntersecting&&go())).observe(s)};
document.readyState=='complete'?start():addEventListener('load',start,{once:true})}
disconnectedCallback(){this.stop();this.on&&this.ev('remove')}
ev(a){for(const n of['select','load'])document[a+'EventListener']('shopify:section:'+n,this.on);document[a+'EventListener']('shopify:section:deselect',this.off)}
stop(){clearTimeout(this.t);this.o?.disconnect();this.s?.remove()}
get(){try{return localStorage.getItem('ah-welcome')}catch(e){}}
set(v){if(!this.D)try{localStorage.setItem('ah-welcome',v)}catch(e){}}
open(){if(!this.d.open){this.r=document.activeElement;this.d.showModal();this.set(1)}}
success(){const b=this.querySelector('[data-body]');b.replaceChildren(this.querySelector('template').content.cloneNode(true));this.set(1);b.querySelector('.ah-wp__h').focus()}
static decide(u,t){return/customer_posted=true/.test(u)||/taken|already|exist/i.test(t)?'ok':t?'err':'native'}
async send(e,f){
e.preventDefault();
const b=f.querySelector('[type=submit]'),m=f.querySelector('[data-msg]'),n=()=>{this.set('p');f.submit()};
b.disabled=true;m.textContent='';
try{
const r=await fetch(f.action,{method:'POST',body:new FormData(f)}),x=new DOMParser().parseFromString(await r.text(),'text/html').querySelector('#'+f.id+' [data-err]'),t=x?x.textContent.trim():'',k=this.constructor.decide(r.url,t);
if(k=='err'){m.textContent=t;b.disabled=false;return f.querySelector('[type=email]').focus()}
k=='ok'?this.success():n()}catch(err){n()}}
async copy(c){
const el=this.querySelector('[data-code]');
try{await navigator.clipboard.writeText(el.textContent.trim())}catch(e){const r=document.createRange(),s=getSelection();r.selectNodeContents(el);s.removeAllRanges();s.addRange(r);document.execCommand('copy')}
c.textContent=this.querySelector('[data-copied]').textContent=c.dataset.done}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
